import { render, staticRenderFns } from "./medicalDetail.vue?vue&type=template&id=0acdc879&scoped=true&"
import script from "./medicalDetail.vue?vue&type=script&lang=js&"
export * from "./medicalDetail.vue?vue&type=script&lang=js&"
import style0 from "./medicalDetail.vue?vue&type=style&index=0&id=0acdc879&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acdc879",
  null
  
)

export default component.exports